import { render, staticRenderFns } from "./Habilidad.vue?vue&type=template&id=92b84180&"
import script from "./Habilidad.vue?vue&type=script&lang=js&"
export * from "./Habilidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports